import React from 'react'
import "../styles/PrivacyPolicy.css"
const TermsOfUse = () => {
    return (
        <>
            <div className=' min-[670px]:m-[4rem] text-justify max-[670px]:text-left max-[670px]:m-[2rem] '>
                <div className='bold text-[35px] text-center'>
                    Terms of Use
                </div>
                <div className='text-justify max-[670px]:text-left mt-10'>
                    These Terms of Use (“Terms”) apply to all Starter, Bronze, Silver, and Gold users of the YR IT  SOLUTIONS form-building platform (“Platform”) and visitors to the YR IT  SOLUTIONS website (“Website”) at www.YR IT  SOLUTIONS.com. By using the Platform or Website, you agree to these Terms.

                </div>
                <div className=''>
                    <div className='privacy-sub'>
                        1. Who May Use the Platform / Subscriptions

                    </div>
                    <div className=''>
                        You may use the Platform only if you comply with these Terms and, for paid subscriptions, pay the required fees.

                    </div>
                    <div className='privacy-sub'>
                        2. Prohibited Activities

                    </div>
                    <div className=''>
                        You are responsible for your use of the Platform and must not:
                        <ul className=' list-disc ml-3 '>
                            <li>
                                Share your login credentials.

                            </li>
                            <li>
                                Violate any applicable laws.

                            </li>
                            <li>
                                Use the Platform for spamming, phishing, fraud, defamation, harassment, or promoting illegal activities.

                            </li>
                            <li>

                                Collect sensitive information without permission.
                            </li>
                            <li>
                                Include copyrighted or trademarked content without authorization.

                            </li>
                            <li>

                                Promote violence or harm.
                            </li>
                            <li>

                                Collect sexually explicit content or promote prostitution.
                            </li>
                        </ul>
                        <div className='mt-2'>
                            YR IT  SOLUTIONS may remove forms violating these terms and suspend or terminate accounts at its discretion.

                        </div>
                        <div className='privacy-sub'>

                            3. Forms and Submissions
                        </div>

                    </div>
                    <div className=''>

                    </div>
                    You are responsible for the content you create using the Platform. By making content public, you grant YR IT  SOLUTIONS a license to use and display it. You waive any intellectual property claims against YR IT  SOLUTIONS related to such content.
                </div>
                <div className="privacy-sub">

                    4. Account Creation & Security
                </div>
                <div className=''>
                    Provide valid information to create an account. Do not share your login credentials. Automated access to the Platform is prohibited.

                </div>
                <div className='privacy-sub'>
                    5. Payments, Renewals, etc.

                </div>
                <div className=''>
                    <ul className=' list-disc ml-3 '>
                        <li>
                            <b>

                                Payments:
                            </b>
                            Taxes may apply. Payments are processed through third-party providers.

                        </li>
                        <li>

                            <b>
                                Automatic Renewal:

                            </b>
                            Subscriptions auto-renew until canceled.
                        </li>
                        <li>
                            <b>

                                Upgrades/Downgrades:
                            </b>
                            Upgrading or downgrading affects form limits and storage.
                        </li>
                        <li>
                            <b>
                                Refund Policy:

                            </b>
                            Cancel within 30 days for a refund if purchased directly from YR IT  SOLUTIONS. Refunds for purchases through the Apple App Store or Google Play are subject to their policies.

                        </li>
                    </ul>
                    <div className='privacy-sub'>
                        6. Use of Data

                    </div>
                    <div className=''>
                        You are responsible for the data you collect. YR IT  SOLUTIONS can use your data to provide the Platform, customer support, and protect against cyberattacks. See the privacy policy for more details.

                    </div>
                </div>
            </div>
        </>
    )
}

export default TermsOfUse